import styled from 'styled-components';

interface FormLabelProps {
  required?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const FormLabel = styled.label<FormLabelProps>`
  font-weight: 500;
  color: #374151;
  font-size: ${props => {
    switch (props.size) {
      case 'small': return '0.75rem';
      case 'large': return '1rem';
      default: return '0.875rem';
    }
  }};
  
  ${props => props.required && `
    &::after {
      content: ' *';
      color: #dc2626;
    }
  `}
`;